import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const uploadSingleFileClasses = generateUtilityClasses(
  'AFUploadSingleFile',
  ['uploadButton', 'uploadIcon', 'fileInput']
);
